import {useMemo, useState} from "react";
import {Col, Row} from "antd";
import {TextField, Tooltip} from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import RemoveIcon from "@material-ui/icons/Remove";

const FormElement = ({onchange, onDelete, value, hideDeleteBtn = false}) => {

    const [defaultValue] = useState(value)

    const [touched, setTouched] = useState({
        Name: false,
        Email: false,
        RespEmail: false,
        Tel: false,
    })

    const [errors, setErrors] = useState({
        Name: false,
        Email: false,
        RespEmail: false,
        Tel: false,
    })

    const _errors = useMemo(() => (errors.Name + errors.Tel + errors.Email + errors.RespEmail)>0, [errors])

    const handleChange = (change) => onchange && onchange(change)

    const handleNameChange = (newName) => {

        if (touched.Name && (newName.trim().length === 0))
            setErrors({...errors, Name: true})
        else setErrors({...errors, Name: false})

        handleChange({...value, Name: newName, _error: _errors});
    }

    const handleEmailChange = (newEmail) => {

        const emailFormat = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        if (touched.Email && !(newEmail.match(emailFormat)))
            setErrors({...errors, Email: true})
        else setErrors({...errors, Email: false})

        handleChange({...value, Email: newEmail, _error: _errors});

    }
    const handleRespEmailChange = (newEmail) => {

        const emailFormat = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        if (touched.RespEmail && !(newEmail.match(emailFormat)))
            setErrors({...errors, RespEmail: true})
        else setErrors({...errors, RespEmail: false})

        handleChange({...value, RespEmail: newEmail, _error: _errors});

    }

    const handleTelChange = (newTel) => {

        const telFormat = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/

        if (touched.Tel && !(newTel.match(telFormat)))
            setErrors({...errors, Tel: true})
        else setErrors({...errors, Tel: false})

        handleChange({...value, Tel: newTel, _error: _errors})

    }

    const handleNameFieldTouched = () => setTouched({...touched, Name: true})
    const handleEmailFieldTouched = () => setTouched({...touched, Email: true})
    const handleRespEmailFieldTouched = () => setTouched({...touched, RespEmail: true})
    const handleTelFieldTouched = () => setTouched({...touched, Tel: true})

    const handleDeletion = () => onDelete && onDelete()

    return (
        <Row justify='space-between' style={{paddingRight: 30, paddingLeft: 30, marginBottom: 10}}>
            <Col>
                <TextField
                    label='Nom'
                    defaultValue={defaultValue.Name}
                    error={errors.Name}
                    helperText={errors.Name && 'Le nom est requis'}
                    onClick={handleNameFieldTouched}
                    onChange={event => handleNameChange(event.target.value)}
                />
            </Col>
            <Col>
                <TextField
                    label='Email'
                    defaultValue={defaultValue.Email}
                    error={errors.Email}
                    helperText={errors.Email && 'Entrez un email valide'}
                    onClick={handleEmailFieldTouched}
                    onChange={event => handleEmailChange(event.target.value)}
                />
                <TextField
                    label='Responsable Email'
                    defaultValue={defaultValue.RespEmail}
                    error={errors.RespEmail}
                    helperText={errors.RespEmail && 'Entrez un email valide'}
                    onClick={handleRespEmailFieldTouched}
                    onChange={event => handleRespEmailChange(event.target.value)}
                />
            </Col>
            <Col>
                <TextField
                    label='Telephone'
                    defaultValue={defaultValue.Tel}
                    error={errors.Tel}
                    helperText={errors.Tel && 'Entrez un numero de telephone valide'}
                    onClick={handleTelFieldTouched}
                    onChange={event => handleTelChange(event.target.value)}
                />
            </Col>
            <Col hidden={hideDeleteBtn}>
                <Tooltip title={'Supprimer'}>
                    <IconButton color='secondary' onClick={handleDeletion}>
                        <RemoveIcon/>
                    </IconButton>
                </Tooltip>
            </Col>
        </Row>
    )

}

export default FormElement
